export default __webpack_public_path__ + "static/main_mobile_v3_en-40bf2cd3886c2f1e534b04b202634dac.mp4";